import { Handshake } from "@phosphor-icons/react";
import { t } from "i18next";
import { useLocation } from "react-router-dom";

import { AddCollaboratorForm } from "@/components";
import type { ModalProps } from "@/shared.types";
import { Circle, Heading, Modal } from "@/ui";

interface LocationState {
  courseId: string;
  partnerId: string;
}

export const AddCollaboratorModal = ({ show, onClose }: ModalProps) => {
  const location = useLocation();
  const state = location.state as LocationState;
  const courseId = state?.courseId;
  const partnerId = state?.partnerId;

  return (
    <Modal
      show={show}
      title={
        <div className="flex flex-col gap-y-2">
          <Heading
            containerClassName="items-center"
            heading={t("collaborators.add_collaborator")}
            left={
              <Circle>
                <Handshake size={24} className="text-tertiary-800" />
              </Circle>
            }
          />
          <span className="text-base text-neutral-700">
            *{t("error.required_fields")}
          </span>
        </div>
      }
      onClose={onClose}
    >
      <AddCollaboratorForm
        onClose={onClose}
        courseId={courseId}
        partnerId={partnerId}
      />
    </Modal>
  );
};
